<ng-template #orderStatusEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">{{ orderEditingNew ? 'New order status' : 'Edit order status' }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<form [formGroup]="orderForm" (ngSubmit)="saveOrderRow()">
		<div class="modal-body text-dark">
			<div class="container-fluid px-0">
				<div class="row">
					<div class="col-md-4" *ngIf="!orderEditingNew">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Status ID</mat-label>
							<input matInput formControlName="order_status_id" readonly />
						</mat-form-field>
					</div>
					<div class="col-md-4">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Language ID</mat-label>
							<input matInput type="number" formControlName="language_id" />
						</mat-form-field>
					</div>
					<div class="col-md-4">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Name</mat-label>
							<input matInput formControlName="name" />
						</mat-form-field>
					</div>
					<div class="col-12 mb-2">
						<mat-checkbox formControlName="isdispatch">Dispatch</mat-checkbox>
					</div>
					<div class="col-md-6">
						<label class="d-block text-dark small mb-1">Badge background</label>
						<div class="d-flex align-items-start flex-wrap status-color-row">
							<input
								type="color"
								class="status-color-wheel"
								[value]="orderHex('badge_bg')"
								(input)="onPickerInput(orderForm, 'badge_bg', $event)"
								title="Open color picker" />
							<mat-form-field appearance="outline" class="status-color-text flex-grow-1">
								<mat-label>CSS value (optional)</mat-label>
								<input matInput formControlName="badge_bg" placeholder="#rrggbb, rgb(), or name" autocomplete="off" />
							</mat-form-field>
						</div>
					</div>
					<div class="col-md-6">
						<label class="d-block text-dark small mb-1">Badge text color</label>
						<div class="d-flex align-items-start flex-wrap status-color-row">
							<input
								type="color"
								class="status-color-wheel"
								[value]="orderHex('badge_fg')"
								(input)="onPickerInput(orderForm, 'badge_fg', $event)"
								title="Open color picker" />
							<mat-form-field appearance="outline" class="status-color-text flex-grow-1">
								<mat-label>CSS value (optional)</mat-label>
								<input matInput formControlName="badge_fg" placeholder="#rrggbb, rgb(), or name" autocomplete="off" />
							</mat-form-field>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer text-end">
			<button mat-stroked-button color="primary" type="submit" [disabled]="orderForm.invalid">
				<mat-icon>save</mat-icon> Save
			</button>
			<button mat-button type="button" (click)="cancelOrderEdit()" class="ms-2">Cancel</button>
		</div>
	</form>
</ng-template>

<ng-template #poStatusEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title-po">{{ poEditingNew ? 'New PO status' : 'Edit PO status' }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<form [formGroup]="poForm" (ngSubmit)="savePoRow()">
		<div class="modal-body text-dark">
			<div class="container-fluid px-0">
				<div class="row">
					<div class="col-md-4" *ngIf="!poEditingNew">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Status ID</mat-label>
							<input matInput formControlName="status_id" readonly />
						</mat-form-field>
					</div>
					<div class="col-md-8">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Name</mat-label>
							<input matInput formControlName="name" />
						</mat-form-field>
					</div>
					<div class="col-md-6">
						<label class="d-block text-dark small mb-1">Badge background</label>
						<div class="d-flex align-items-start flex-wrap status-color-row">
							<input
								type="color"
								class="status-color-wheel"
								[value]="poHex('color')"
								(input)="onPickerInput(poForm, 'color', $event)"
								title="Open color picker" />
							<mat-form-field appearance="outline" class="status-color-text flex-grow-1">
								<mat-label>CSS value (optional)</mat-label>
								<input matInput formControlName="color" placeholder="#rrggbb, rgb(), or name" autocomplete="off" />
							</mat-form-field>
						</div>
					</div>
					<div class="col-md-6">
						<label class="d-block text-dark small mb-1">Badge text color</label>
						<div class="d-flex align-items-start flex-wrap status-color-row">
							<input
								type="color"
								class="status-color-wheel"
								[value]="poHex('badge_fg')"
								(input)="onPickerInput(poForm, 'badge_fg', $event)"
								title="Open color picker" />
							<mat-form-field appearance="outline" class="status-color-text flex-grow-1">
								<mat-label>CSS value (optional)</mat-label>
								<input matInput formControlName="badge_fg" placeholder="#rrggbb, rgb(), or name" autocomplete="off" />
							</mat-form-field>
						</div>
					</div>
					<div class="col-md-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Receive</mat-label>
							<input matInput type="number" formControlName="receive" />
						</mat-form-field>
					</div>
					<div class="col-md-3">
						<mat-form-field appearance="outline" class="w-100">
							<mat-label>Print</mat-label>
							<input matInput type="number" formControlName="print" />
						</mat-form-field>
					</div>
					<div class="col-md-3 d-flex align-items-center">
						<mat-checkbox formControlName="pocompleted">PO completed</mat-checkbox>
					</div>
					<div class="col-md-3 d-flex align-items-center">
						<mat-checkbox formControlName="summary">Summary</mat-checkbox>
					</div>
				</div>
			</div>
		</div>
		<div class="modal-footer text-end">
			<button mat-stroked-button color="primary" type="submit" [disabled]="poForm.invalid">
				<mat-icon>save</mat-icon> Save
			</button>
			<button mat-button type="button" (click)="cancelPoEdit()" class="ms-2">Cancel</button>
		</div>
	</form>
</ng-template>

<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{ color }}-5">
						<h4 class="card-title">
							<i class="material-icons" (click)="back()">arrow_left</i> Status maintenance
						</h4>
						<p class="card-category"></p>
					</div>
					<div class="card-body">
						<h5 class="mb-3">Order statuses (sales / credits / quotes)</h5>
						<button mat-stroked-button color="success" type="button" (click)="newOrderRow()" class="mt-2 mb-2">
							<mat-icon>add</mat-icon> New order status
						</button>
						<div *ngIf="loadingOrder" class="text-center py-4">
							<mat-spinner diameter="40"></mat-spinner>
						</div>
						<div class="table ov" *ngIf="!loadingOrder">
							<div class="text-right mb-1" *ngIf="orderRows.length === 0">
								<span>No order statuses</span>
							</div>
							<table class="table table-sm table-striped table-hover table-bordered table-fixed ov" *ngIf="orderRows.length">
								<thead class="header">
									<tr>
										<th class="header" scope="col">ID</th>
										<th class="header" scope="col">Lang</th>
										<th class="header" scope="col">Name</th>
										<th class="header text-center" scope="col">Dispatch</th>
										<th class="header" scope="col">Badge BG</th>
										<th class="header" scope="col">Badge FG</th>
										<th class="header text-center" scope="col">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let r of orderRows">
										<td>{{ r.order_status_id }}</td>
										<td>{{ r.language_id }}</td>
										<td>{{ r.name }}</td>
										<td class="text-center">{{ r.isdispatch }}</td>
										<td>
											<span *ngIf="r.badge_bg" class="color-swatch" [style.background-color]="r.badge_bg"></span>
											{{ r.badge_bg }}
										</td>
										<td>{{ r.badge_fg }}</td>
										<td class="text-center text-nowrap">
											<button mat-stroked-button color="primary" type="button" (click)="editOrderRow(r)" class="mr-1">
												<mat-icon>edit</mat-icon>
											</button>
											<button mat-stroked-button color="warn" type="button" (click)="deleteOrderRow(r)">
												<mat-icon>delete</mat-icon>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<hr class="my-4" />

						<h5 class="mb-3">PO statuses</h5>
						<button mat-stroked-button color="success" type="button" (click)="newPoRow()" class="mt-2 mb-2">
							<mat-icon>add</mat-icon> New PO status
						</button>
						<div *ngIf="loadingPo" class="text-center py-4">
							<mat-spinner diameter="40"></mat-spinner>
						</div>
						<div class="table ov" *ngIf="!loadingPo">
							<div class="text-right mb-1" *ngIf="poRows.length === 0">
								<span>No PO statuses</span>
							</div>
							<table class="table table-sm table-striped table-hover table-bordered table-fixed ov" *ngIf="poRows.length">
								<thead class="header">
									<tr>
										<th class="header" scope="col">ID</th>
										<th class="header" scope="col">Name</th>
										<th class="header" scope="col">Color (BG)</th>
										<th class="header" scope="col">Badge FG</th>
										<th class="header text-center" scope="col">Rcv</th>
										<th class="header text-center" scope="col">Prt</th>
										<th class="header text-center" scope="col">Done</th>
										<th class="header text-center" scope="col">Sum</th>
										<th class="header text-center" scope="col">Actions</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let r of poRows">
										<td>{{ r.status_id }}</td>
										<td>{{ r.name }}</td>
										<td>
											<span *ngIf="r.color" class="color-swatch" [style.background-color]="r.color"></span>
											{{ r.color }}
										</td>
										<td>{{ r.badge_fg }}</td>
										<td class="text-center">{{ r.receive }}</td>
										<td class="text-center">{{ r.print }}</td>
										<td class="text-center">{{ r.pocompleted }}</td>
										<td class="text-center">{{ r.summary }}</td>
										<td class="text-center text-nowrap">
											<button mat-stroked-button color="primary" type="button" (click)="editPoRow(r)" class="mr-1">
												<mat-icon>edit</mat-icon>
											</button>
											<button mat-stroked-button color="warn" type="button" (click)="deletePoRow(r)">
												<mat-icon>delete</mat-icon>
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>

					<hr class="my-4" />

					<h5 class="mb-1">Open Orders &#8212; Excluded Statuses</h5>
					<p class="text-muted small mb-3">Orders whose status is checked here will be hidden from the Open Orders list.</p>
					<div *ngIf="loadingExcluded" class="text-center py-4">
						<mat-spinner diameter="40"></mat-spinner>
					</div>
					<div *ngIf="!loadingExcluded">
						<div class="row">
							<div class="col-md-3 col-sm-4 col-6 mb-2" *ngFor="let s of excludedStatusRows">
								<mat-checkbox [(ngModel)]="s.excluded">
									<span class="small">{{ s.order_status_id }} &#8212; {{ s.name }}</span>
								</mat-checkbox>
							</div>
						</div>
						<button mat-stroked-button color="primary" type="button" (click)="saveExcludedStatuses()" class="mt-2">
							<mat-icon>save</mat-icon> Save exclusions
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
